<template>
  <transition
    name="slideDown"
    appear
    @before-enter="frozenBody"
    @before-leave="frozenBody"
  >
    <Header v-if="showHeaderFooter" />
  </transition>
  <div
    v-if="showHeaderFooter"
    :style="{ 'margin-top': showHeaderFooter ? '80px' : 0 }"
  >
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in" appear>
        <component :is="Component" />
      </transition>
    </router-view>
  </div>

  <router-view v-if="!showHeaderFooter" v-slot="{ Component }">
    <transition name="fade" mode="out-in" appear>
      <component :is="Component" />
    </transition>
  </router-view>

  <transition
    name="slideUp"
    appear
    @after-enter="releaseBody"
    @after-leave="releaseBody"
  >
    <Footer v-if="showHeaderFooter" />
  </transition>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import Header from './Header.vue';
import Footer from './Footer.vue';

export default defineComponent({
  name: 'Layout',
  components: {
    Header,
    Footer
  },
  setup() {
    const route = useRoute();
    const showHeaderFooter = ref(false);
    const setHeaderFooterVisible = path => {
      showHeaderFooter.value = path !== '/login';
    };
    onMounted(() => {
      setHeaderFooterVisible(route.path);
    });
    watch(
      () => route.path,
      path => {
        setHeaderFooterVisible(path);
      }
    );
    return { showHeaderFooter };
  },
  methods: {
    frozenBody() {
      document.body.style.height = '100vh';
      document.body.style.overflow = 'hidden';
    },
    releaseBody() {
      document.body.style.height = '';
      document.body.style.overflow = '';
    }
  }
});
</script>

<style lang="scss" scoped>
// header隐藏显示动画
.slideDown-enter-active,
.slideDown-leave-active {
  position: relative;
  transition: top 350ms ease;
}

.slideDown-enter-from {
  top: -80px;
}

.slideDown-enter-to {
  top: 0;
}

.slideDown-leave-from {
  top: 0;
}

.slideDown-leave-to {
  top: -80px;
}

// 页面切换动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 250ms ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// footer隐藏显示动画
.slideUp-enter-active,
.slideUp-leave-active {
  position: relative;
  transition: bottom 350ms ease 100ms;
}

.slideUp-enter-from {
  bottom: -100px;
}

.slideUp-enter-to {
  bottom: 0;
}

.slideUp-leave-from {
  bottom: 0;
}

.slideUp-leave-to {
  bottom: -100px;
}
</style>
